import { ReactNode } from 'react'

interface Props {
  children: ReactNode
}

export const ColorfulIcon = ({ children }: Props) => {
  return <span className="text-interactive">{children}</span>
}
